import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Cookie from "js-cookie";
import userService from "@/global/service/user";
import authService from "@/global/service/auth";
// import settingService from "@/global/service/setting";
// import { Message } from "element-ui";
import Store from "@/store/index";
Vue.use(VueRouter);

const appRouter = new VueRouter({
  mode: "history",
  // eslint-disable-next-line
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

appRouter.firstInit = false;

appRouter.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.meta.title) document.title = to.meta.title;
  try {
    const TOKEN = Cookie.get("token");
    const toWelcome = /welcome/.test(to.path);
    let hasRole = null;
    if (!TOKEN && to.name !== "WelcomeHomeSelf") {
      next({ name: "WelcomeHomeSelf", replace: true });
      return;
    }
    if (!TOKEN && to.name == "WelcomeHomeSelf") {
      next();
      return;
    }
    if (TOKEN && !toWelcome && appRouter.firstInit) {
      appRouter.firstInit = false;
    }
    if (!appRouter.firstInit && TOKEN) {
      appRouter.firstInit = true;
      const userInfo = await userService.info();
      const auth = await authService.authPermissions();
      const authPermissions = Object.values(auth.user_permissions);
      hasRole = authPermissions.length ? true : false;
      Store.commit("getAuthPermissions", authPermissions);
      Store.commit("getUserAvatar", userInfo.avatar.path);
      Store.commit("getUserPhone", userInfo.phone_number);
      Store.commit("getUserName", userInfo.nickname || userInfo.name);
    }
    if (TOKEN && !hasRole && !toWelcome) {
      next({ name: "WelcomeHomeSelf", replace: true });
    }
    if (TOKEN && to.name === "WelcomeHomeSelf") {
      hasRole && next({ name: "Home", replace: true });
    }
    // if (TOKEN && to.name === "WelcomeHomeSelf") {
    //   hasRole && next({ name: "Home", replace: true });
    //   !hasRole && next({ name: "WelcomeHomeSelf", replace: true });
    // }
    // if (TOKEN && to.name === "WelcomeHomeSelf" && hasRole) {
    //   next({ name: "Home", replace: true });
    // }
    next();
  } catch {
    next();
  }
  // if (to.meta.title) document.title = to.meta.title;
  // const TOKEN = Cookie.get("token");
  // if (!TOKEN) {
  //   const referer = window.location.href;
  //   const PASSPORT_PREFIX = "https://passport" + process.env.VUE_APP_DOMAIN;
  //   window.location.href = PASSPORT_PREFIX + "/?referer=" + referer;
  //   return;
  // }
  // let all_finished = Store.state.settingStage.all_finished;
  // if (!appRouter.firstInit) {
  //   appRouter.firstInit = true;
  //   const userInfo = await userService.info();
  //   const auth = await authService.authPermissions();
  //   const authPermissions = Object.values(auth.user_permissions);
  //   let settingStage = await settingService.stages();
  //   all_finished =
  //     settingStage.bank_verify_finished &&
  //     settingStage.base_info_finished &&
  //     settingStage.realname_verify_finished;
  //   settingStage.all_finished = all_finished;
  //   Store.commit("getAuthPermissions", authPermissions);
  //   Store.commit("getUserAvatar", userInfo.avatar.path);
  //   Store.commit("getUserName", userInfo.nickname || userInfo.name);
  //   Store.commit("getSettingStage", settingStage);
  // }
  // let toSettingPage = to.matched.some(ele => {
  //   return ele.name == "Setting" || ele.name == "Home";
  // });

  // if (!toSettingPage) {
  //   if (all_finished) {
  //     next();
  //   } else {
  //     Message.error("请完成个人信息认证，只有认证成功的小伙伴才能在平台工作哦");
  //     next({ name: "Home" });
  //   }
  // } else {
  //   next();
  // }
});

appRouter.afterEach(() => {
  NProgress.done();
});

export default appRouter;
